import * as React from "react";
import { forwardRef } from "react";
const SvgTrackingLocationCorner = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M27 27L20.3848 27L20.3848 7.61524L1 7.61523L1 1L22.9531 1L23.2451 1.29297L26.707 4.75488L27 5.04688L27 27Z", fill: "#DE1A22", stroke: "currentColor", strokeWidth: 2 }));
const ForwardRef = forwardRef(SvgTrackingLocationCorner);
export { ForwardRef as ReactComponent };
